<template>
  <BaseModal
    :is-open
    title="Unsaved changes"
    description="Your unsaved changes will be lost if you don't save them."
    size="small"
    @close="cancel"
  >
    <p>Changes you made have not been saved. Would you like to save before leaving?</p>
    <template #actions>
      <BaseButton variant="outlined" color="grey" @click="discard">Don't save</BaseButton>
      <BaseButton variant="ghost" color="grey" @click="cancel">Cancel</BaseButton>
      <FeedbackButton success-message="Changes saved successfully." @click="save">
        Save
      </FeedbackButton>
    </template>
  </BaseModal>
</template>

<script>
import BaseButton from "./BaseButton.vue";
import BaseModal from "./BaseModal.vue";
import FeedbackButton from "./FeedbackButton.vue";

export default {
  name: "UnsavedChangesModal",
  components: { BaseModal, BaseButton, FeedbackButton },
  props: {
    /**
     * Whether the modal should be visible or not.
     */
    isOpen: { type: Boolean, default: false },
    /** Callback rather than emit: FeedbackButton awaits the returned Promise to drive its loading/success UI. */
    saveAction: { type: Function, default: () => {} },
  },
  emits: ["cancel", "discard"],
  methods: {
    cancel() {
      /**
       * The discard/save modal has been closed, meaning that the user wants to
       * remain on the current page without saving.
       */
      this.$emit("cancel");
    },
    discard() {
      /**
       * The user wants to discard unsaved changes and proceed to the next step.
       */
      this.$emit("discard");
    },
    async save() {
      return this.saveAction();
    },
  },
};
</script>
